import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import userReducer from "./User/reducer";
import listReducer from "./List/reducer";
import screenReducer from "./Screen/reducer";
import patientReducer from "./Patient/reducer";
import headerReducer from "./Header/reducer";
import { persistStore, persistReducer } from "redux-persist";
// defaults to localStorage for web
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "root",
  storage,
};

const rootReducer = combineReducers({
  user: userReducer,
  list: listReducer,
  screen: screenReducer,
  patient: patientReducer,
  header: headerReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);
const store = configureStore({ reducer: persistedReducer });
const persistor = persistStore(store);
// store.subscribe(() => console.log("update State", store.getState()));

export { store, persistor };

// Inferred from the store itself, so it always matches the real reducer
// shape (including redux-persist's _persist metadata) instead of the
// hand-maintained XInitialStateType interfaces used at useSelector call
// sites today.
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
